import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace Name {
  export interface SchemaPropertyDefinition {
    first: OpportunitySchema.StringPropertyDefinition;
    last: OpportunitySchema.StringPropertyDefinition;
    middle: OpportunitySchema.StringPropertyDefinition;
    preferred: OpportunitySchema.StringPropertyDefinition;
    title: OpportunitySchema.OptionsPropertyDefinition;
  }

  export interface SchemaContract {
    first?: string | null;
    last?: string | null;
    middle?: string | null;
    preferred?: string | null;
    title?: string | null;
  }

  export interface Model {
    first: string | null;
    last: string | null;
    middle: string | null;
    preferred: string | null;
    title: string | null;
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      first: contract.first ?? null,
      last: contract.last ?? null,
      middle: contract.middle ?? null,
      preferred: contract.preferred ?? null,
      title: contract.title ?? null
    };
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return model as Partial<SchemaContract>;
  }

  export namespace SchemaContract {
    export function getDisplayName({
      first,
      last,
      title,
      middle
    }: SchemaContract): string {
      return [title || '', first || '', middle || '', last || '']
        .filter((x) => !!x)
        .join(' ');
    }

    export function getShortDisplayName({ first, last }: SchemaContract) {
      return `${first ?? ''} ${last ?? ''}`.trim();
    }
  }

  export namespace Model {
    export function getDisplayName(c: Model): string {
      const { first, last, title, middle } = c;
      return [title || '', first || '', middle || '', last || '']
        .filter((x) => !!x)
        .join(' ');
    }

    export function getShortDisplayName({ first, last }: SchemaContract) {
      return `${first ?? ''} ${last ?? ''}`.trim();
    }
  }
}
